import { render, staticRenderFns } from "./colonne_comment.vue?vue&type=template&id=16d3e4b0"
import script from "./colonne_comment.js?vue&type=script&lang=js&external"
export * from "./colonne_comment.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports